module.exports = __webpack_public_path__ + "img/gasnatural.bbff9878.svg";